export const Modal = ({
  show,
  header,
  body,
  footer,
  id,
  className,
  closeBtn = true,
}) => {
  const display = show[0] ? "d-block" : "d-none"

  const handleCloseClick = () => show[1](false)

  return (
    <div
      {...(id ? { id: id } : {})}
      className={`modal ${display} ${className}`}
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{header}</h5>
            {closeBtn && (
              <button
                onClick={handleCloseClick.bind(this)}
                type="button"
                className="btn-close"
              ></button>
            )}
          </div>
          <div className={"modal-body" + (!footer ? " pb-3" : "")}>{body}</div>
          {footer && <div className="modal-footer"> {footer} </div>}
        </div>
      </div>
    </div>
  )
}

/*

// ejemplo de uso 1: Custom component body

const Cont = () => (
  <h2>kkkk</h2>
)

const showModalEjemplo = useState(true)

<Modal 
  show   = {showModalEjemplo}
  header = {<center>dsdsd!!</center>}
  body   = {<Cont />}
/>


// ejemplo de uso 2: Custom buttons component

const ModalWithFooterButtons = () => {
  const showModalEjemplo = useState(true)
  const footerModalEjemplo = () => { return (
    <>
      <button type="button" className="btn btn-secondary">Close</button>
      <button type="button" className="btn btn-primary">Save changes</button>
    </>
  )}

  const Cont = () => (
    <h2>kkkk</h2>
  )

  return (
    <Modal 
      show   = {showModalEjemplo}
      header = "titulo"
      body   = {<Cont />}
      footer = {footerModalEjemplo()}
    />
  )
}

*/

// modales derivadas
// 1. ModalDump
// 2. ModalOk
// 3. ModalError
